import React from 'react';
import HomeContainer from '../HomeContainer';

const Registration3 = () => {
  return (
    <HomeContainer>
    <div>
      <h5>Advanced Generative Ai</h5>
      <p>Coming soon...</p>
      {/* Form can be added here */}
    </div>
    </HomeContainer>
  );
};

export default Registration3;
